var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more",on:{"click":function($event){return _vm.$emit('more')}}},[_c('img',{attrs:{"src":"https://www.xaryxx.com/images/more.png","alt":"","srcset":""}}),_vm._v("\n查看更多\n      ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-894fbbfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/more-button.vue
// module id = null
// module chunks = 